import { Component, OnInit, Input, inject } from '@angular/core';
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { CerrixDialogService } from "@app/shared/organisms/cerrix-dialog/cerrix-dialog-service.component";
import { ProcessedDocumentsService } from "@app/document-intelligence/services/processed-documents-service";
import { DocumentModel } from "@models/documents/documentmodel";
import { DocumentManagerService } from "@app/controls/testing/advanced/detail-new/common/services/document-manager.service";
import { ProcessedDocumentUploadModel } from "@app/document-intelligence/models/ProcessedDocumentUploadModel";
import { DocumentMethods } from "@methods/DocumentMethods";
import { firstValueFrom } from "rxjs";

@Component({
    selector: 'generate-ai-risks-dialog',
    templateUrl: './generate-ai-risks-dialog.component.html',
    styleUrls: ['./generate-ai-risks-dialog.component.scss'],
    standalone: false,
})
export class GenerateAiRisksDialogComponent implements OnInit {
    private _tabs = inject(TabService);
    pages = inject(Pages);

    @Input() public name: string;
    @Input() public showGoBack: boolean = true;
    showCreai = false;
    creaiDocument: DocumentModel | null = null;
    creaiAllowedExtensions = ".jpeg,.jpg,.png,.bmp,.pdf,.docx,.xls,.xlsx,.pptx,";
    creaiGeneratingRisks: boolean = false;
    private _dialogService = inject(CerrixDialogService);
    private _processedDocumentsService = inject(ProcessedDocumentsService);
    private _documentsService = inject(DocumentManagerService);
    protected documentConfig: {
        maxUploadSizeInMb: number;
        allowedFileExtensions: string;
    };

    ngOnInit() {
        this._documentsService.getDocumentConfig().subscribe((documentConfig) => {
            this.documentConfig = {
                ...documentConfig,
                allowedFileExtensions: documentConfig.allowedFileExtensions
                    .split(",")
                    .filter((ext) => this.creaiAllowedExtensions.includes(ext))
                    .join(","),
            };
        });
    }

    async getCreaiSetting() {
        this.showCreai = await firstValueFrom(this._processedDocumentsService.canAccess());
    }

    goBack(): void {
        this.creaiDocument = null;
        this._dialogService.closeDialog("generateAiRisks");
        this._dialogService.openDialog("addNewRisk");
    }

    async generateAiRisks() {
        this.creaiGeneratingRisks = true;
        try {
            let document: ProcessedDocumentUploadModel = {
                Documents: [this.creaiDocument],
            };
            let id = await firstValueFrom(this._processedDocumentsService.postDocument(document));
            if (id) {
                this._dialogService.closeDialog("generateAiRisks");
                this._tabs.generateTab(this.pages.NewRiskAi, id, `(R) New Risk`);
            }
        } finally {
            this.creaiGeneratingRisks = false;
        }
    }

    protected onFileSelection(selection: { fileList: FileList; isBrowse: boolean }) {
        if (selection.fileList?.length) {
            const files = this._documentsService.filterAllowedFiles(
                selection.fileList,
                this.documentConfig.allowedFileExtensions,
            );

            if (
                files.length &&
                this._documentsService.validateUploadLimit(
                    files,
                    this.documentConfig.maxUploadSizeInMb,
                )
            ) {
                const droppedDocuments = DocumentMethods.convertFileListToDocumentModel(files);
                this.creaiDocument = droppedDocuments[0];
            }
        }
    }

    private openTab(guid: string, name: string): void {
        this._tabs.generateTab(this.pages.RiskDetail, guid, name);
    }
}
